import { GET_FILTERS_GROUPS } from "constants/action-types";
import { handleActions } from "redux-actions";

export interface IState {
    error?: Error;
    isFetching: boolean;
    results: string[];
}

export const initialState: IState = {
    isFetching: false,
    results: [],
};

export const filtersGroups = handleActions<IState, any>(
    {
        [GET_FILTERS_GROUPS.FETCH.START]: (state: IState) => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [GET_FILTERS_GROUPS.FETCH.SUCCESS]: (state: IState, { error, payload }: any) => {
            if (error) {
                return {
                    ...state,
                    error,
                };
            }
            return {
                ...state,
                isFetching: false,
                results: payload,
            };
        },
        [GET_FILTERS_GROUPS.RESET]: () => initialState,
    },
    initialState
);
